import buildInfo from "../../assets/build-info.json";

export interface BuildInfo {
  buildNumber: string;
  buildDate: string;
}

export const CURRENT_BUILD_INFO: BuildInfo = buildInfo;

export function getBuildKey(info: BuildInfo): string {
  return `${info.buildNumber}-${info.buildDate}`;
}

export const CURRENT_BUILD_KEY = getBuildKey(CURRENT_BUILD_INFO);
